'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { ArrowRight, Ticket } from 'lucide-react';

/** Pages where the bottom CTA should be hidden */
const HIDDEN_ON = ['/book'];

export default function BottomNavCTA() {
  const pathname = usePathname();

  if (HIDDEN_ON.some((p) => pathname?.startsWith(p))) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 px-3.5 pb-3 pt-1.5 sm:px-6 md:hidden pointer-events-none">
      {/* Subtle backdrop overlay */}
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-white/95 via-white/80 to-transparent" />

      <Link
        href="/book"
        prefetch={false}
        className="pointer-events-auto relative flex min-h-[46px] w-full items-center justify-between gap-3 overflow-hidden rounded-xl bg-[linear-gradient(315deg,#288ac4_0%,#16325c_100%)] px-4 py-2.5 shadow-[0_6px_20px_rgba(85,178,213,0.35)] active:scale-[0.99] transition-transform"
      >
        {/* Left */}
        <div className="flex items-center gap-2.5 min-w-0">
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-white/20">
            <Ticket className="h-4 w-4 text-white" strokeWidth={2.25} />
          </span>
          <div className="min-w-0 truncate">
            <p className="text-[13px] font-black leading-tight text-white truncate">Book Reservation</p>
            <p className="text-[10px] font-semibold text-white/85 mt-0.5 tracking-wide truncate">Delivered in 10–60 mins • GDS format</p>
          </div>
        </div>

        {/* Right arrow */}
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-white/20">
          <ArrowRight className="h-4 w-4 text-white" strokeWidth={3} />
        </span>

        {/* Shimmer */}
        <span className="pointer-events-none absolute inset-0 -translate-x-full animate-[shimmer_2.8s_ease-in-out_infinite] bg-gradient-to-r from-transparent via-white/10 to-transparent" />
      </Link>
    </div>
  );
}
